module.exports = __webpack_public_path__ + "img/crew_onboarding_short.2ab1dd1c.jpg";